// Bump ANNOUNCEMENT_VERSION whenever the copy changes meaningfully and you
// want it to show again even to users who already dismissed an earlier
// version in the same browser session.
export const ANNOUNCEMENT_VERSION = 'v1';

export const ANNOUNCEMENT_TITLE = 'Hello citizens of Dannytopia,';

export const ANNOUNCEMENT_MESSAGE = [
    "I am unable to continue upkeep of this lovely platform and community I've built. For this reason, I will be switching to a new platform in the coming months to offload some of this burden. For now, you'll notice your subscription should not renew at your next billing cycle. Additional purchases (like videos and custom photo requests) are also closed at this time.",
    "When I am up and running on a different platform, any content you've already purchased here will be available to you there at no extra cost. (Please keep the email you used handy.)",
    "This has been a wildly fun and freeing journey for me, and I appreciate all the support you've given me!",
    'Until I see you again,',
];

export const ANNOUNCEMENT_SIGNATURE = '-Danny (Ruler of Dannytopia)';
